import React from "react";

const CopyTimesDropdown = ({
  days = [],
  excludeIndex,
  selectedTargets = [],
  onToggleTarget,
  onApply,
  onCancel,
}) => {
  return (
    <div className="absolute top-8 right-0 z-20 w-56 rounded-lg border border-gray-600 bg-gray-800 shadow-lg sm:top-10">
      <div className="border-b border-gray-700 px-3 py-2 text-xs text-gray-300">
        Copy times to
      </div>
      <div className="max-h-64 space-y-1 overflow-y-auto p-2">
        {days.map(
          (dayLabel, index) =>
            index !== excludeIndex && (
              <label
                key={dayLabel}
                className="flex cursor-pointer items-center space-x-2 rounded px-2 py-1 text-xs text-gray-200 hover:bg-gray-700 sm:text-sm"
              >
                <input
                  type="checkbox"
                  checked={selectedTargets.includes(index)}
                  onChange={() => onToggleTarget(index)}
                  className="form-checkbox h-3 w-3"
                />
                <span>{dayLabel}</span>
              </label>
            ),
        )}
      </div>
      <div className="flex items-center justify-between border-t border-gray-700 px-3 py-2">
        <button
          onClick={onCancel}
          className="text-xs text-gray-300 hover:text-white"
        >
          Cancel
        </button>
        <button
          onClick={onApply}
          disabled={selectedTargets.length === 0}
          className={`rounded px-3 py-1 text-xs ${selectedTargets.length === 0 ? "bg-gray-700 text-gray-400" : "bg-white text-black hover:bg-gray-200"}`}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default CopyTimesDropdown;
